/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import { isIE } from 'react-device-detect';
import useTranslation from '../../hooks/useTranslation';
import './styles.scss';

const EpPaginationResults = ({
  tableData, getDataFunc, filterData, integrationFuncData, columns,
  setCurrentPageNumber,
}) => {
  const LinesPerPage = useTranslation('Lines per page');
  const Results = useTranslation('Results');
  const Of = useTranslation('of');

  const handleChangeOption = (pagesizes) => {
    getDataFunc(0, pagesizes, filterData, integrationFuncData, columns);
    setCurrentPageNumber(1);
  };

  const { totalItens, itensPerPage, page } = tableData;

  const itensPerPageMultiplication = itensPerPage * (page + 1);

  const validateLastUserPage = itensPerPageMultiplication > totalItens ? totalItens
    : itensPerPageMultiplication;

  const nanValidation = !Number.isNaN(itensPerPageMultiplication);

  const firstUserPage = nanValidation ? itensPerPageMultiplication - (itensPerPage - 1) : 0;
  const lastUserPage = nanValidation ? `- ${validateLastUserPage}` : '';

  const totalItensValidation = totalItens !== undefined ? `${Of} ${totalItens}` : '';

  return (
    <div className="pagination-results">
      <span className="pagination-results__lines-pages">
        {LinesPerPage}
      </span>

      <select
        className={`${isIE ? '' : 'form-select'} form-select-sm pagination-results__select`}
        onChange={(e) => {
          handleChangeOption(Number(e.target.value));
        }}
        disabled={!nanValidation}
      >
        {[25, 50, 100].map(pageSizeMap => (
          <option key={pageSizeMap} value={pageSizeMap}>
            {pageSizeMap}
          </option>
        ))}
      </select>
      <span className="pagination-results__total-pages">
        {`${firstUserPage} ${lastUserPage} ${totalItensValidation} ${Results}`}
      </span>
    </div>
  );
};

export default EpPaginationResults;

EpPaginationResults.defaultProps = {
  tableData: null,
  filterData: null,
  columns: null,
  integrationFuncData: null,
  setCurrentPageNumber: null,
};

EpPaginationResults.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  tableData: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.symbol,
    PropTypes.func,
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.object),
  ])),
  getDataFunc: PropTypes.func.isRequired,
  filterData: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])),
  columns: PropTypes.arrayOf(PropTypes.object),
  integrationFuncData: PropTypes.func,
  setCurrentPageNumber: PropTypes.func,
};
